import {
  type ExternalLoginProviders,
  ModuleName,
  Screen,
  type SkinPageConfig,
  templates,
} from '@nosinovacao/nosid-mfe-common';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useGetLoginOptions } from './-hooks/login-options.hook';
import { useAssociateSocialNetwork, useRemoveSocialNetwork } from './-hooks/social-networks.hook';
import { type HomePageProps } from './-model/props';
import { HomePageLight, HomePageWooDark, HomePageWoo } from './-skins';
import { ErrorPage } from '@/components/errors';

export const Route = createFileRoute('/(home)/home')({
  component: RouteComponent,
  errorComponent: ErrorPage,
  staticData: {
    module: ModuleName.Home,
    screen: Screen.LandingPage,
  },
});

function RouteComponent() {
  const { data: loginOptions, isLoading } = useGetLoginOptions();
  const { mutateAsync } = useAssociateSocialNetwork();
  const { mutateAsync: removeSocialNetwork, isPending: removeSocialNetworkLoading } =
    useRemoveSocialNetwork();
  const [associateSocialNetworkLoading, setAssociateSocialNetworkLoading] =
    useState<ExternalLoginProviders | null>(null);
  const props: HomePageProps = {
    usernameAliases: loginOptions?.UsernameAliases ?? [],
    socialNetworks: loginOptions?.SocialNetworks.map((sn) => sn.Provider) ?? [],
    isLoading,
    removeSocialNetwork,
    removeSocialNetworkLoading,
    associateSocialNetworkLoading,
    associateSocialNetwork: async (provider) => {
      setAssociateSocialNetworkLoading(provider);
      try {
        await mutateAsync(provider);
      } finally {
        setAssociateSocialNetworkLoading(null);
      }
    },
  };
  return templates.getSkinSelector(getSkinConfig(props));
}

export function getSkinConfig(props: HomePageProps): SkinPageConfig {
  return {
    skins: [
      {
        selector: 'isWooTvTemplate',
        component: <HomePageWooDark {...props} />,
      },
      {
        selector: 'isWooTemplate',
        component: <HomePageWoo {...props} />,
      },
    ],
    defaultValue: <HomePageLight {...props} />,
  };
}
